export const CONTACT_US_LINK = 'https://contact-us.welltech.com/walkfit.html';
